import React from 'react';
/* Redux */
import { connect } from 'react-redux';
/* CSS */
import './style.css';

const mapStateToProps = state => {
  return {
    overlay: state.overlay
  }
}

export const Overlay = ({ target = "", enableBackgroundColor = false, clickEvent = function() {}, render, ...props }) => {
  const isVisible = (props.overlay[target] && props.overlay[target].isVisible) ? true : false;

  const closeOverlay = function(event, callback) {
    const currentTarget = event.currentTarget;
    const target = event.target;

    if (currentTarget === target) {
      callback();
    }
  }

  return (
    <div className={`overlay ${isVisible ? "overlay--is-visible" : ""} ${enableBackgroundColor ? "overlay--enabled-background-color" : ""}`} onClick={event => closeOverlay(event, clickEvent)}>
      { render() }
    </div>
  );
}

export default connect(mapStateToProps, null)(Overlay);



// WEBPACK FOOTER //
// ./src/components/shared/Overlay/index.js